import { minOrderLabel, formatNumber } from './format.js';

/**
 * Normalize product names for grouping "similar" products. Catches:
 * - casing differences (iOl vs Oil)
 * - extra whitespace (Guling  240 vs Guling 240)
 * - trailing variants (Premium, Import, Baru, New, Extra, Plus)
 */
export function normalizeItemName(name) {
  if (!name) return '';
  return name
    .toLowerCase()
    .replace(/\s+/g, ' ')
    .trim()
    .replace(/\s+(premium|import|baru|new|extra|plus|original|export)\s*$/i, '')
    .trim();
}

export function parseMoq(moqStr) {
  const digits = String(moqStr || '1').replace(/\D/g, '');
  const num = parseInt(digits, 10);
  return isNaN(num) || num <= 0 ? 1 : num;
}

/** Effective minimum order quantity (multiplier applied) as a number. */
export function effectiveMoq(item) {
  if (!item) return 1;
  return item.qty ?? ((item.moq_multiplier ?? 1) * parseMoq(item.minimum_order || item.pack_qty));
}

/** Margin of an item over its buy price: `{ nominal, pct }`, both null when not computable. */
export function itemMargin(item) {
  const buy = item?.buy_price != null ? Number(item.buy_price) : 0;
  const sell = item?.item_price != null ? Number(item.item_price) : null;
  const nominal = sell != null && buy > 0 ? sell - buy : null;
  const pct = nominal != null ? Math.round((nominal / buy) * 100) : null;
  return { nominal, pct };
}

export function formatMultipliedMoq(item) {
  if (!item) return '';
  return minOrderLabel(formatNumber(effectiveMoq(item)), item.unit);
}